import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up com_pop",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "sign_form custom_scroll activity" }
const _hoisted_4 = {
  for: "isNotice2",
  class: "checkbox_wrap2"
}
const _hoisted_5 = {
  for: "isSecret",
  class: "checkbox_wrap2"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "li_con" }
const _hoisted_8 = { class: "file_wrap" }
const _hoisted_9 = { for: "area_file" }
const _hoisted_10 = { class: "file_list" }
const _hoisted_11 = ["src", "onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src", "onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "_flex _center btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Comment = _resolveComponent("Comment")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, "액션 활동 공지 " + _toDisplayString($setup.state.idx === 0 ? "등록" : "수정"), 1),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("label", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                id: "isNotice2",
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.data.isNotice) = $event)),
                "true-value": 1,
                "false-value": 0
              }, null, 512), [
                [_vModelCheckbox, $setup.state.data.isNotice]
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("em", null, null, -1)),
              _cache[13] || (_cache[13] = _createElementVNode("span", null, "공지 여부", -1))
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("label", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                id: "isSecret",
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.data.isSecret) = $event)),
                "true-value": 1,
                "false-value": 0
              }, null, 512), [
                [_vModelCheckbox, $setup.state.data.isSecret]
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("em", null, null, -1)),
              _cache[15] || (_cache[15] = _createElementVNode("span", null, "비밀글 여부", -1))
            ])
          ]),
          ($setup.state.data.isSecret === 1)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _cache[16] || (_cache[16] = _createElementVNode("label", {
                  for: "pw",
                  class: "form_li_tit"
                }, "비밀번호", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "pw",
                  type: "password",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.data.pw) = $event)),
                  placeholder: "비밀번호를 입력해주세요."
                }, null, 512), [
                  [_vModelText, $setup.state.data.pw]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", null, [
            _cache[17] || (_cache[17] = _createElementVNode("label", {
              for: "title",
              class: "form_li_tit"
            }, "제목", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "title",
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.data.title) = $event)),
              placeholder: "제목을 입력해주세요."
            }, null, 512), [
              [_vModelText, $setup.state.data.title]
            ])
          ]),
          _createElementVNode("li", _hoisted_7, [
            _cache[18] || (_cache[18] = _createElementVNode("label", {
              for: "editor1",
              class: "form_li_tit",
              "aria-placeholder": "내용을 입력해주세요."
            }, "내용", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "editor1",
              name: "editor1",
              class: "custom_scroll",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.data.content) = $event))
            }, null, 512), [
              [_vModelText, $setup.state.data.content]
            ])
          ]),
          _createElementVNode("li", _hoisted_8, [
            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "form_li_tit" }, "첨부", -1)),
            _createElementVNode("label", _hoisted_9, [
              _createElementVNode("input", {
                id: "area_file",
                type: "file",
                placeholder: "",
                accept: "image/*",
                multiple: "",
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.handleFiles && $setup.handleFiles(...args)))
              }, null, 32),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "file_box_wrap" }, "‘파일첨부’ 버튼을 클릭하거나 파일을 드래그하여 첨부해주세요", -1)),
              _cache[20] || (_cache[20] = _createElementVNode("span", {
                class: "blue_btn",
                style: {"display":"flex","justify-content":"center","align-items":"center"}
              }, "파일첨부", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("p", { class: "p_info" }, "200M 이하 JPG, PNG 파일을 첨부해주세요.", -1))
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.fileList, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "file",
                  key: idx
                }, [
                  _createElementVNode("img", {
                    class: "file_item",
                    src: item.file,
                    alt: "",
                    onClick: ($event: any) => ($setup.showImgModal(item.file))
                  }, null, 8, _hoisted_11),
                  _createElementVNode("button", {
                    class: "file_del icon_wrap",
                    onClick: ($event: any) => ($setup.fileRemove(item.idx))
                  }, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("img", {
                      src: "img/close_02.png",
                      alt: ""
                    }, null, -1)
                  ]))], 8, _hoisted_12)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.file, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "file",
                  key: index
                }, [
                  _createElementVNode("img", {
                    class: "file_item",
                    src: $setup.CommonUtils.getImgUrl(item),
                    alt: "",
                    onClick: ($event: any) => ($setup.showImgModal($setup.CommonUtils.getImgUrl(item)))
                  }, null, 8, _hoisted_13),
                  _createElementVNode("button", {
                    class: "file_del icon_wrap",
                    onClick: ($event: any) => ($setup.removeFile(index))
                  }, [...(_cache[23] || (_cache[23] = [
                    _createElementVNode("img", {
                      src: "img/close_02.png",
                      alt: ""
                    }, null, -1)
                  ]))], 8, _hoisted_14)
                ]))
              }), 128))
            ])
          ])
        ]),
        ($setup.state.idx !== 0)
          ? (_openBlock(), _createBlock(_component_Comment, {
              key: 0,
              idx: $setup.state.idx
            }, null, 8, ["idx"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        ($setup.state.idx === 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "submit_btn _130 _main_blue",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.add && $setup.add(...args)))
            }, "등록"))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "submit_btn _130 _main_blue",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.modify && $setup.modify(...args)))
            }, "수정"))
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.state.isShowModal = false)),
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}